// API Base URL Configuration
// Automatically detects environment:
// - Development (npm run dev): http://localhost:5074
// - Production (npm run build): https://api.drunkenhippos.de
// Can be overridden with VITE_API_BASE_URL environment variable

const getApiBaseUrl = (): string => {
  // Check if environment variable is set
  if (import.meta.env.VITE_API_BASE_URL) {
    return import.meta.env.VITE_API_BASE_URL;
  }
  
  // Default based on environment
  if (import.meta.env.DEV) {
    // Development mode - use local .NET API
    return 'http://localhost:5074';
  } else {
    // Production mode - use production API
    return 'https://api.drunkenhippos.de';
  }
};

const API_BASE_URL = getApiBaseUrl();

export { API_BASE_URL };
